import { JsonObject, JsonProperty } from 'typescript-json-serializer';

export enum MAGNITUDE {
    ANGLE = 'ANGLE',
    APPARENT_ENERGY = 'APPARENT_ENERGY',
    APPARENT_POWER = 'APPARENT_POWER',
    CONCENTRATION = 'CONCENTRATION',
    CURRENT = 'CURRENT',
    CONDUCTIVITY = 'CONDUCTIVITY',
    DEGREE_DAYS = 'DEGREE_DAYS',
    DISTANCE = 'DISTANCE',
    ENERGY = 'ENERGY',
    ENERGY_PER_MASS = 'ENERGY_PER_MASS',
    ENERGY_PER_SURFACE = 'ENERGY_PER_SURFACE',
    ENERGY_PER_VOLUME = 'ENERGY_PER_VOLUME',
    FREQUENCY = 'FREQUENCY',
    ILLUMINANCE = 'ILLUMINANCE',
    MASS = 'MASS',
    MASS_CONCENTRATION = 'MASS_CONCENTRATION',
    MASS_FLOW = 'MASS_FLOW',
    MASS_FRACTION = 'MASS_FRACTION',
    MOLAR_CONCENTRATION = 'MOLAR_CONCENTRATION',
    MONETARY = 'MONETARY',
    PERCENTAGE = 'PERCENTAGE',
    PEOPLE = 'PEOPLE',
    POWER = 'POWER',
    POWER_PER_SURFACE = 'POWER_PER_SURFACE',
    PRESSURE = 'PRESSURE',
    REACTIVE_ENERGY = 'REACTIVE_ENERGY',
    REACTIVE_POWER = 'REACTIVE_POWER',
    SOUND_INTENSITY = 'SOUND_INTENSITY',
    SPEED = 'SPEED',
    TEMPERATURE = 'TEMPERATURE',
    TIME = 'TIME',
    UNITS = 'UNITS',
    VOLTAGE = 'VOLTAGE',
    VOLUME = 'VOLUME',
    VOLUME_NORMALISED = 'VOLUME_NORMALISED',
    VOLUME_PER_SURFACE = 'VOLUME_PER_SURFACE',
    VOLUME_FLOW = 'VOLUME_FLOW',
    VOLUME_FLOW_NORMALISED = 'VOLUME_FLOW_NORMALISED',
    EURO = 'EURO',
    DOLLAR = 'DOLLAR',
    POUND = 'POUND',
    YEN = 'YEN',
    TURKISH_LIRA = 'TURKISH_LIRA',
    MALAYSIAN_RINGGIT = 'MALAYSIAN_RINGGIT',
    QATAR_RIYAL = 'QATAR_RIYAL',
    SWISS_FRANC = 'SWISS_FRANC',
    KRONE = 'KRONE',
    SOUTH_AFRICA = 'SOUTH_AFRICA',
    INDONESIAN_RUPIAH = 'INDONESIAN_RUPIAH',
    PESO_DOMINICANO = 'PESO_DOMINICANO',
    COLON = 'COLON',
    INR = 'INR',
    HONG_KONG_DOLLAR = 'HONG_KONG_DOLLAR',
    ARABIA_SAUDY = 'ARABIA_SAUDY',
    MOROCCO = 'MOROCCO',
    CROATIA = 'CROATIA',
    BRAZILIAN_REAL = 'BRAZILIAN_REAL',
    ROMANIAN_LEU = 'ROMANIAN_LEU',
    BULGARIAN_LEV = 'BULGARIAN_LEV',
    POLISH_ZLOTY = 'POLISH_ZLOTY',
    TAIWANESE_DOLLAR = 'TAIWANESE_DOLLAR',
    ISRAELI_SHEKEL = 'ISRAELI_SHEKEL',
    CANADIAN_DOLLAR = 'CANADIAN_DOLLAR',
    ARAB_EMIRATES_DIRHAM = 'ARAB_EMIRATES_DIRHAM',
}

@JsonObject()
export class Magnitude {
    constructor(
        @JsonProperty({ required: true }) readonly magnitude: MAGNITUDE,
        @JsonProperty({ required: true }) readonly units: string[]
    ) {}
}
